import { ServerConfig } from "@/config/config";
import { User } from "@/models/user";
import { Axios } from "@/services/auth-service";
import Vue from "vue";

export const UserService = new Vue({
	computed: {
		generalUrl():string {
			return `${ServerConfig.host}/admin/users`;
		}
	},
	methods: {
		async searchByUserName(username:string):Promise<User[]> {
			let result = await Axios.get(`${this.generalUrl}/search/${encodeURIComponent(username)}`);
			return result.data.map((u:any) => new User(u));
		},
		async getById(userId:number):Promise<User>{
			let result = await Axios.get(`${this.generalUrl}/${userId}`);
			return new User(result.data);
		},
		async getLoginAsUserUrl(user:User):Promise<{url:string, expiryDate:Date}>{
			let token = await Axios.post(`${this.generalUrl}/${user.id}/login`);
			return {
				url: `${ServerConfig.mainAppUrl}?refreshToken=${token.data.refreshToken}`,
				expiryDate: new Date(token.data.expiryDate)
			};
		},
		async getLoginAsAdminUrl(user:User):Promise<{url:string, expiryDate:Date}>{
			let token = await Axios.post(`${this.generalUrl}/${user.id}/login-as-admin`);
			return {
				url: `${ServerConfig.mainAppUrl}?refreshToken=${token.data.refreshToken}`,
				expiryDate: new Date(token.data.expiryDate)
			};
		},
		async loginAsAdmin(user:User):Promise<void>{
			let res = await this.getLoginAsAdminUrl(user);
			window.open(res.url, "_blank");
		},
		async loginAsUser(user:User):Promise<void> {
			let res = await this.getLoginAsUserUrl(user);
			window.open(res.url, "_blank");
		},
	}
});